import { get as getLocalStore } from '@/helpers/persistor';
import { ALPHANUMERIC } from '@/helpers/rides';
import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';
import {
    SET_PROFILE,
    UPDATE_PROFILE,
    SET_ACCOUNT_DATA,
    UPDATE_ACCOUNT_DATA,
    SET_SORT_KEY,
    UPDATE
} from '@/store/actions/user';

const initialState = {
    // gigya profile
    profile: getLocalStore('user.profile') || {},
    // gigya user data object
    data: {},

    // dealer from data.preferredDealer
    dealer: null,

    // home from data.address
    home: null,

    // saved rides page
    saved: {
        sort: {
            bookmarks: ALPHANUMERIC,
            eventBookmarks: ALPHANUMERIC,
            rides: ALPHANUMERIC
        }
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_PROFILE: {
            const { profile } = action.data;
            return { ...state, profile };
        }

        case UPDATE_PROFILE: {
            return {
                ...state,
                profile: { ...state.profile, ...action.data }
            };
        }

        case SET_ACCOUNT_DATA: {
            const data = action.data;
            return { ...state, data };
        }

        case UPDATE_ACCOUNT_DATA: {
            return {
                ...state,
                data: { ...state.data, ...action.data }
            };
        }

        case SET_SORT_KEY: {
            const { key, value } = action.data;
            return {
                ...state,
                saved: {
                    ...state.saved,
                    sort: { ...state.saved.sort, [key]: value }
                }
            };
        }

        case UPDATE: {
            const { key, value } = action.data;
            return { ...state, [key]: value };
        }

        case AUTH_INVALIDATE: {
            return initialState;
        }

        default: {
            return state;
        }
    }
};
